import { Observable } from 'rxjs';
import { Actions } from '../../actions';
import * as authActions from '../../auth/actions';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom } from 'rxjs/operators';
import { push } from 'connected-react-router';
import { LoginUserSuccess } from '../../auth/action-creators';
import AppState from '../../state';
import { isPublicRoute, isAuthRoute } from '../common';
import { NoOp } from '../../ui/action-creators';

export const userLoggedInEpic = (action$: Observable<Actions>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Actions, LoginUserSuccess>(
      authActions.LOGIN_USER_SUCCESS
    ),
    withLatestFrom(state$),
    map(([_, state]) => {

      if (state.router.location.pathname !== '/') {
        if (
          (isPublicRoute(state.router.location.pathname) && !isAuthRoute(state.router.location.pathname)) ||
          !isAuthRoute(state.router.location.pathname)
        ) {
          return new NoOp();
        }

        if (state.auth.newUser && !state.auth.registrationData?.username) {
          return new NoOp();
        }
      }

      return push(`/dashboard${window.location.search}`)
    })
  );